function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["style", "placeholder", "debounce", "onChange", "minLength"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import Form from "react-bootstrap/Form";
import { GoSearch } from "react-icons/go";
import { DebounceInput } from "react-debounce-input";
var styles = {
  icon: {
    color: "#00000059",
    padding: "0 0.75rem"
  },
  input: {
    paddingLeft: "calc(1.5rem + 16px)"
  }
};
function SearchBar(props) {
  var style = props.style,
    placeholder = props.placeholder,
    _props$debounce = props.debounce,
    debounce = _props$debounce === void 0 ? true : _props$debounce,
    _onChange = props.onChange,
    minLength = props.minLength,
    otherProps = _objectWithoutProperties(props, _excluded);
  var allowedPattern = /^[a-zA-Z0-9.@ ]*$/; // Allow only letters, numbers, '.' and '@'

  var inputProps = _objectSpread({
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Search",
    // onKeyPress: (event) => {
    //   // Allow only numbers
    //   if (!allowedPattern.test(event.key)) {
    //     event.preventDefault();
    //   }
    // },
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    style: _objectSpread(_objectSpread({}, style), styles.input)
  }, otherProps);
  var input = debounce ? /*#__PURE__*/React.createElement(DebounceInput, _extends({
    element: Form.Control,
    minLength: minLength !== null && minLength !== void 0 ? minLength : 1,
    debounceTimeout: 1000
  }, inputProps)) : /*#__PURE__*/React.createElement(Form.Control, inputProps);
  return /*#__PURE__*/React.createElement("div", {
    className: "position-relative w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-absolute h-100 d-inline-flex align-items-center",
    style: styles.icon
  }, /*#__PURE__*/React.createElement(GoSearch, null)), input);
}
export default /*#__PURE__*/React.memo(SearchBar);